<template>
  <section class="city-lab network-module-ai">
    <nav class="lab-crumb">网格平台 / AI案例生成</nav>
    <ai-case-generator ref="generator" kind="network" page @close="back" @saved="saved" />
  </section>
</template>
<script>
import AiCaseGenerator from '../components/AiCaseGenerator.vue'

export default {
  name: 'NetworkModuleAi', components: { AiCaseGenerator },
  data () { return { leaving: false } },
  async beforeRouteLeave (to, from, next) {
    const generator = this.$refs.generator
    if (this.leaving || !generator) return next()
    if (generator.requesting || generator.saving) return next(false)
    if (generator.generating) { await generator.stop(); return next(!generator.generating) }
    next()
  },
  methods: {
    back () { this.leaving = true; this.$router.push(this.$route.query.from === 'library' ? '/cases' : '/network/modules') },
    saved (row) { this.leaving = true; this.$router.replace('/network/modules/' + encodeURIComponent(row.id)) }
  }
}
</script>
